import { render, staticRenderFns } from "./PoliciesCreate.vue?vue&type=template&id=4be41148&"
import script from "./PoliciesCreate.vue?vue&type=script&lang=js&"
export * from "./PoliciesCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports